import React, {Component} from 'react';
import PropTypes from 'prop-types';
import css from './selectGroup.scss';
import {Query} from 'react-apollo';
import {GET_GROUPS} from '../groupsList/queries';

class SelectGroup extends Component {
	state = {
		name: this.props.group ? this.props.group.name : '-',
		visible: false,
	};
	static propTypes = {
		group: PropTypes.object,
		onSelect: PropTypes.func,
	};
	open = (_) => {
		if (!this.state.visible) {
			this.setState((_) => ({visible: true}));
			document.body.addEventListener('click', this.blurWrapper);
		}
	};
	close = (_) => {
		this.setState((_) => ({visible: false}));
		document.body.removeEventListener('click', this.blurWrapper);
	};
	reset = (_) => {
		this.setState((_) => ({name: '-'}));
	};
	blurWrapper = (e) => {
		if (!this.wrapper.contains(e.target)) {
			this.close();
		}
	};
	componentWillUnmount() {
		document.body.removeEventListener('click', this.blurWrapper);
	}
	select = (group) => {
		if (!group) {
			this.setState(
				(_) => ({name: '-'}),
				(_) => {
					this.props.onSelect(null);
				},
			);
		} else {
			this.setState(
				(_) => ({name: group.name}),
				(_) => {
					this.props.onSelect(group.id);
				},
			);
		}
		this.close();
	};

	render() {
		return (
			<Query query={GET_GROUPS}>
				{({loading, error, data}) => {
					if (loading) {
						return 'Loading';
					}
					if (error) {
						return `Une erreur est survenue ${error.graphQLErrors[0]}`;
					}
					const sortedGroups = data.groups.slice().sort((a, b) => {
						return a.name.localeCompare(b.name);
					});

					return (
						<div
							className={css.wrapper}
							onClick={this.open}
							ref={(n) => (this.wrapper = n)}
							style={{zIndex: this.state.visible ? 1 : 0}}
						>
							<input
								className={css.input}
								type="text"
								value={this.state.name}
								readOnly
							/>
							<ul
								className={
									css.list +
									(this.state.visible ? ' visible' : '')
								}
							>
								<li
									key="empty"
									onClick={(_) => this.select(null)}
								>
									-
								</li>
								{sortedGroups.map((group) => {
									return (
										<li
											key={group.id}
											onClick={(_) => this.select(group)}
										>
											{group.name}
										</li>
									);
								})}
							</ul>
						</div>
					);
				}}
			</Query>
		);
	}
}

export default SelectGroup;



// WEBPACK FOOTER //
// ./src/selectGroup/selectGroup.js